import { PurchasableFragments } from '@/apollo/fragments/purchasable';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { ExpressShipping } from '@/types/api';
import gql from 'graphql-tag';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdateExpressShipping($input: UpdateExpressShippingInput!) {
        updateExpressShipping(input: $input) {
          expressShipping {
            ...Purchasable
          }
        }
      }
      ${PurchasableFragments.Purchasable}
    `,
  },
})
export class UpdateExpressShippingForm extends GraphQLForm<ExpressShipping> {
  @Field({
    static: true,
  })
  public readonly id: string;

  @Field()
  public title: string;

  @Field()
  public description: string;

  @Field()
  public price: number;

  @Field()
  public images: Array<File> | null = null;

  constructor(expressShipping: ExpressShipping) {
    super(expressShipping);
    this.id = expressShipping.id;
    this.title = expressShipping.title;
    this.description = expressShipping.description;
    this.price = expressShipping.price;
  }
}
